import { Seo } from '../components/seo/Seo'
import { Hero } from '../components/home/Hero'
import { Problem } from '../components/home/Problem'
import { HowWeWork } from '../components/home/HowWeWork'
import { ServicesOverview } from '../components/home/ServicesOverview'
import { IndustriesOverview } from '../components/home/IndustriesOverview'
import { ProductsFeature } from '../components/home/ProductsFeature'
import { CasesPreview } from '../components/home/CasesPreview'
import { Proof } from '../components/home/Proof'
import { Testimonials } from '../components/home/Testimonials'
import { InsightsPreview } from '../components/home/InsightsPreview'
import { AboutTeaser } from '../components/home/AboutTeaser'
import { FinalCTA } from '../components/home/FinalCTA'

export function Home() {
  return (
    <>
      <Seo
        title="We build what businesses need next."
        description="Limitlast is a technology company designing and building digital products, software, and systems for organizations ready to evolve."
        path="/"
      />
      <Hero />
      <Problem />
      <HowWeWork />
      <ServicesOverview />
      <IndustriesOverview />
      <ProductsFeature />
      <CasesPreview />
      <Proof />
      <Testimonials />
      <InsightsPreview />
      <AboutTeaser />
      <FinalCTA />
    </>
  )
}
